try{self['workbox:background-sync:4.3.1']&&_()}catch(e){}// eslint-disable-line